import debug from 'debug'
import { allRepoInstances, repoInstance } from '@/repos/helpers/instances'

debug.set('app:repos', allRepoInstances)
debug.set('app:repo', repoInstance)

export default {}
